import { useState } from "react";
import { PhysShell, Field, ResultCard, Stat, primaryBtn } from "./PhysShell.jsx";
import { suvat, round } from "./physcore.js";

const FIELDS = [
  ["u", "Initial velocity u", "m/s"],
  ["v", "Final velocity v", "m/s"],
  ["a", "Acceleration a", "m/s²"],
  ["t", "Time t", "s"],
  ["s", "Displacement s", "m"],
];

export default function Kinematics() {
  const [vals, setVals] = useState({ u: "", v: "", a: "", t: "", s: "" });
  const [res, setRes] = useState(null);

  const set = (k, val) => setVals((p) => ({ ...p, [k]: val }));
  const go = () => {
    const parsed = {};
    for (const k of Object.keys(vals)) {
      const t = vals[k].trim();
      parsed[k] = t === "" ? null : parseFloat(t);
    }
    setRes(suvat(parsed));
  };

  return (
    <PhysShell title="Kinematics (SUVAT)">
      <p style={{ fontSize: 13, color: "#5B5E7A", marginTop: 0 }}>
        Constant acceleration. Fill in any 3 — leave the unknowns blank.
      </p>
      {FIELDS.map(([k, label, unit]) => (
        <Field key={k} label={label} suffix={unit} value={vals[k]} onChange={(e) => set(k, e.target.value)} placeholder="—" />
      ))}
      <button onClick={go} style={primaryBtn}>Solve</button>
      {res && !res.ok && <ResultCard><span style={{ color: "#F8716A" }}>{res.error}</span></ResultCard>}
      {res && res.ok && !res.ambiguous && (
        <ResultCard>
          <div style={{ fontSize: 13, color: "#9A9DBE", marginBottom: 10 }}>SOLVED</div>
          {res.solvedFor.map((k) => {
            const f = FIELDS.find((x) => x[0] === k);
            return <Stat key={k} label={f[1]} value={round(res.result[k], 4)} unit={f[2]} />;
          })}
          {res.steps.length > 0 && (
            <div style={{ marginTop: 12, fontSize: 13, color: "#9A9DBE" }}>
              Equations used: {res.steps.join(" · ")}
            </div>
          )}
        </ResultCard>
      )}
      {res && res.ok && res.ambiguous && (
        <ResultCard>
          <div style={{ fontSize: 13, color: "#F0B72A", marginBottom: 10, lineHeight: 1.5 }}>
            {res.warnings?.[0] || "This input has two valid physical solutions."}
          </div>
          {res.solutions.map((sol, i) => (
            <div key={i} style={{ marginBottom: i === 0 ? 16 : 0, paddingBottom: i === 0 ? 16 : 0, borderBottom: i === 0 ? "1px solid #1C1E2E" : "none" }}>
              <div style={{ fontSize: 13, color: "#9A9DBE", marginBottom: 8 }}>SOLUTION {i + 1}</div>
              {res.solvedFor.map((k) => {
                const f = FIELDS.find((x) => x[0] === k);
                return <Stat key={k} label={f[1]} value={round(sol[k], 4)} unit={f[2]} />;
              })}
            </div>
          ))}
          {res.steps.length > 0 && (
            <div style={{ marginTop: 12, fontSize: 13, color: "#9A9DBE" }}>
              Equations used: {res.steps.join(" · ")}
            </div>
          )}
        </ResultCard>
      )}
    </PhysShell>
  );
}

